import { render, staticRenderFns } from "./InvoiceSection.vue?vue&type=template&id=4bf8f808&scoped=true"
import script from "./InvoiceSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceSection.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceSection.vue?vue&type=style&index=0&id=4bf8f808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8f808",
  null
  
)

export default component.exports